const { cELM } = require("../../utils");

class Phq {
  constructor(options, callback) {
    this.options = options;
    this.callback = callback;
    this.element = cELM("div", "option-block");
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    const _self = this;

    this.options.forEach(op => {
      const _el = cELM("div", "option");

      _el.onclick = function(evt) {
        _el.classList.toggle("option-active");

        const answerEl = cELM("div", "option-block answer");
        answerEl.addELM(cELM("div", "button button-active", op.label));

        _self.element.parentNode.addELM(answerEl);
        _self.element.style.display = "none";

        _self.callback(op.value);
      };

      _el.innerHTML = '<div class="option-text">' + op.label.trim() + "</div>";

      _self.element.addELM(_el);
    });

    return this.element;
  }

  reset() {
    let sibling = this.element.firstChild;
    while (sibling) {
      sibling.classList.remove("option-active");
      sibling = sibling.nextSibling;
    }
    this.selectedOptions = [];
  }

  focus() {}
}

module.exports = Phq;
